export default __webpack_public_path__ + "static/media/visibility-24px.72cdf929.svg";